// extracted by mini-css-extract-plugin
export var divider = "_pr-0";
export var systemMessage = "_pr-1";
export var systemMessageWrapper = "_pr-2";